import { render, staticRenderFns } from "./ExpedientIncidenceForm.vue?vue&type=template&id=59f10bf2&scoped=true"
import script from "./ExpedientIncidenceForm.ts?vue&type=script&lang=ts&external"
export * from "./ExpedientIncidenceForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f10bf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59f10bf2')) {
      api.createRecord('59f10bf2', component.options)
    } else {
      api.reload('59f10bf2', component.options)
    }
    module.hot.accept("./ExpedientIncidenceForm.vue?vue&type=template&id=59f10bf2&scoped=true", function () {
      api.rerender('59f10bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P48/ExpedientIncidenceForm/ExpedientIncidenceForm.vue"
export default component.exports